import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const TextAreaContainer = styled.div`
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.midnight[50]};
    background: ${colorsPalettes.carbon[0]};
    padding: 8px;
    position: relative;

    &:focus-within {
        border: 1px solid ${colorsPalettes.blue[400]};
        box-shadow: 0 3px 5px 0 rgba(42, 62, 82, 0.12);
    }
`;

export const StyledBottomContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const StyledImportSourcesList = styled(Flex)`
    flex: 1.5;
    flex-wrap: wrap;
    gap: 8px;
`;

export const StyledChildrenContainer = styled(Flex)`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    white-space: nowrap;
`;

const BaseOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    z-index: 10;
    justify-content: center;
    border-radius: 3px;
    border: 1px dashed;
`;

export const DropOverlay = styled(BaseOverlay)`
    background: ${colorsPalettes.sky[100]};
    border-color: ${colorsPalettes.sky[500]};
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const ImportingOverlay = styled(BaseOverlay)`
    background: ${colorsPalettes.carbon[25]};
    border-color: ${colorsPalettes.carbon[100]};
    ${setFontVariant("body2", colorsPalettes.carbon[300])}
`;
